import { GRVValidationStateTypes, GRVValidationActionTypes } from "./GRVValidation.type";
import { InitPagedData, resetApiCallState } from "../Utils";

const INITIAL_STATE: GRVValidationStateTypes = {
    fetchAll: resetApiCallState([]),
    fetchPaged: resetApiCallState(InitPagedData),
    fetchOne: resetApiCallState({}),
};

const GRVValidationReducer = (
    state: GRVValidationStateTypes = INITIAL_STATE,
    action: any
): GRVValidationStateTypes => {
    switch (action.type) {
        case GRVValidationActionTypes.FETCH_ALL_GRV_VALIDATION:
            return {
                ...state,
                fetchAll: {
                    error: null,
                    payload: [],
                    isPending: true,
                    isSuccessful: false,
                },
            };
        case GRVValidationActionTypes.FETCH_ALL_GRV_VALIDATION_RESET:
            return {
                ...state,
                fetchAll: resetApiCallState([]),
            };
        case GRVValidationActionTypes.FETCH_ALL_GRV_VALIDATION_FAILURE:
            return {
                ...state,
                fetchAll: {
                    payload: [],
                    isPending: false,
                    isSuccessful: false,
                    error: action.payload,
                },
            };
        case GRVValidationActionTypes.FETCH_ALL_GRV_VALIDATION_SUCCESS:
            return {
                ...state,
                fetchAll: {
                    error: null,
                    isPending: false,
                    isSuccessful: true,
                    payload: action.payload,
                },
            };

        // ---------
        
        case GRVValidationActionTypes.FETCH_PAGED_GRV_VALIDATION:
            return {
                ...state,
                fetchPaged: {
                    error: null,
                    payload: InitPagedData,
                    isPending: true,
                    isSuccessful: false,
                },
            };
        case GRVValidationActionTypes.FETCH_PAGED_GRV_VALIDATION_RESET:
            return {
                ...state,
                fetchPaged: resetApiCallState(InitPagedData),
            };
        case GRVValidationActionTypes.FETCH_PAGED_GRV_VALIDATION_FAILURE:
            return {
                ...state,
                fetchPaged: {
                    payload: InitPagedData,
                    isPending: false,
                    isSuccessful: false,
                    error: action.payload,
                },
            };
        case GRVValidationActionTypes.FETCH_PAGED_GRV_VALIDATION_SUCCESS:
            return {
                ...state,
                fetchPaged: {
                    error: null,
                    isPending: false,
                    isSuccessful: true,
                    payload: action.payload,
                },
            };

        // ---------

        case GRVValidationActionTypes.FETCH_ONE_GRV_VALIDATION:
            return {
                ...state,
                fetchOne: {
                    error: null,
                    payload: {},
                    isPending: true,
                    isSuccessful: false,
                },
            };
        case GRVValidationActionTypes.FETCH_ONE_GRV_VALIDATION_RESET:
            return {
                ...state,
                fetchAll: resetApiCallState([]),
            };
        case GRVValidationActionTypes.FETCH_ONE_GRV_VALIDATION_FAILURE:
            return {
                ...state,
                fetchOne: {
                    payload: {},
                    isPending: false,
                    isSuccessful: false,
                    error: action.payload,
                },
            };
        case GRVValidationActionTypes.FETCH_ONE_GRV_VALIDATION_SUCCESS:
            return {
                ...state,
                fetchOne: {
                    error: null,
                    isPending: false,
                    isSuccessful: true,
                    payload: action.payload,
                },
            };

        default:
            return state;
    }
};

export default GRVValidationReducer;
